import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-BannerShape",
  "use": "svg-icon-BannerShape-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"svg-icon-BannerShape\"><path d=\"M21.2 3H2.8C1.2 3 0 4.2 0 5.8v12.5C0 19.8 1.2 21 2.8 21h18.5c1.5 0 2.8-1.2 2.8-2.8V5.8C24 4.2 22.8 3 21.2 3zM1.5 18.2V5.8c0-.7.6-1.2 1.2-1.2h6.8v15H2.8c-.7-.1-1.3-.7-1.3-1.4zm21 0c0 .7-.6 1.2-1.2 1.2H11v-15h10.2c.7 0 1.2.6 1.2 1.2v12.6z\" /><path d=\"M13.2 8.2h7v1.5h-7zm0 6h7v1.5h-7zm0-3h5v1.5h-5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol